import {
  EVENT_NAME_CONTRACT_PURCHASE_VIEWED,
  PRODUCT_CATEGORIES_AD,
} from 'src/app/analytics';

export const getProductCategories = (adBudgetPurchased: string): string[] => {
  const productCategories = [PRODUCT_CATEGORIES_AD];

  if (adBudgetPurchased === EVENT_NAME_CONTRACT_PURCHASE_VIEWED) {
    productCategories.push('contract');
  }

  return productCategories;
};
